import { ImageSlice } from '../../prismicio-types'
import styles from './Image.module.css'
import { isFilled } from '@prismicio/client'
import { ResponsiveImage } from './ResponsiveImage'

export class Image {
	static render(props: ImageSlice) {
		const {
			primary: { image }
		} = props

		return /* HTML */ `
			<div class="${styles.Main}">${isFilled.image(image) ? ResponsiveImage.render({ image }) : ''}</div>
		`
	}
}
